import type {
  AbilityId,
  ChatMessage,
  MatchResults,
  MeProfile,
  MinigameState,
  MissionState,
  RoomState,
  WorldModifiers,
} from '@kokun/shared';
import { Store } from './store';

export type Screen = 'loading' | 'welcome' | 'game' | 'creator';

export interface Waypoint {
  x: number;
  y: number;
  z: number;
  label: string;
  icon: string;
}

export interface Floater {
  id: number;
  x: number;
  y: number;
  z: number;
  text: string;
  color: string;
  born: number;
}

export interface GameUI {
  screen: Screen;
  profile: MeProfile | null;
  mode: 'online' | 'offline' | null;
  room: RoomState | null;
  you: string | null;
  mission: MissionState | null;
  minigame: MinigameState | null;
  results: MatchResults | null;
  modifiers: WorldModifiers | null;
  cooldowns: Partial<Record<AbilityId, number>>;
  prompt: string | null;
  chat: ChatMessage[];
  paintedUntil: number;
  paused: boolean;
  scoreboard: boolean;
  carrying: boolean;
}

export const ui = new Store<GameUI>({
  screen: 'loading',
  profile: null,
  mode: null,
  room: null,
  you: null,
  mission: null,
  minigame: null,
  results: null,
  modifiers: null,
  cooldowns: {},
  prompt: null,
  chat: [],
  paintedUntil: 0,
  paused: false,
  scoreboard: false,
  carrying: false,
});

/** Datos de alta frecuencia (no pasan por el store para no re-renderizar la UI cada frame). */
export const live = {
  waypoints: [] as Waypoint[],
  floaters: [] as Floater[],
  project: (_x: number, _y: number, _z: number): { x: number; y: number; behind: boolean } => ({ x: 0, y: 0, behind: true }),
  fps: 0,
};

let floaterId = 0;
export function floatText(x: number, y: number, z: number, text: string, color = '#ffffff') {
  live.floaters.push({ id: ++floaterId, x, y, z, text, color, born: performance.now() });
  if (live.floaters.length > 20) live.floaters.shift();
}
